import { render } from "./SavedCardDisplay.vue?vue&type=template&id=c99b287e&scoped=true"
import script from "./SavedCardDisplay.vue?vue&type=script&lang=ts"
export * from "./SavedCardDisplay.vue?vue&type=script&lang=ts"

import "./SavedCardDisplay.vue?vue&type=style&index=0&id=c99b287e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c99b287e"

export default script